import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + '/';

const Apis = {
    getAppointmentResult: host + 'reportResult/getAppointmentResult',//约稿统计
};

export const getAppointmentResult = (body, callBack) => {  //约稿统计
    request({url:Apis.getAppointmentResult, body, callBack});
};